export default "__VITE_ASSET__SnqRsFi3__"